import type {
  ApproveKnowledge,
  ApproveKnowledgeFulfilled,
  ApproveKnowledgeRejected,
  FetchTopicPinnedKnowledge,
  FetchTopicPinnedKnowledgeFulfilled,
  FetchTopicPinnedKnowledgeRejected,
  FetchTopicsForPinnedKnowledge,
  FetchTopicsForPinnedKnowledgeFulfilled,
  FetchTopicsForPinnedKnowledgeRejected,
  RejectTopicKnowledge,
  RejectTopicKnowledgeFulfilled,
  RejectTopicKnowledgeRejected,
  UpdateTopicPinnedKnowledge,
  UpdateTopicPinnedKnowledgeFulfilled,
  UpdateTopicPinnedKnowledgeRejected,
} from "domains/pinAddReject/actionTypes";
import { PinAddRejectActionTypes } from "domains/pinAddReject/actionTypes";

export const fetchTopicPinnedKnowledge = (meta: FetchTopicPinnedKnowledge["meta"]): FetchTopicPinnedKnowledge => ({
  meta,
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE,
});

export const fetchTopicPinnedKnowledgeFulfilled = (
  meta: FetchTopicPinnedKnowledgeFulfilled["meta"],
  payload: FetchTopicPinnedKnowledgeFulfilled["payload"],
): FetchTopicPinnedKnowledgeFulfilled => ({
  meta,
  payload,
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE_FULFILLED,
});

export const fetchTopicPinnedKnowledgeRejected = (
  meta: FetchTopicPinnedKnowledgeRejected["meta"],
): FetchTopicPinnedKnowledgeRejected => ({
  meta,
  type: PinAddRejectActionTypes.FETCH_PINNED_KNOWLEDGE_REJECTED,
});

export const updateTopicPinnedKnowledge = (meta: UpdateTopicPinnedKnowledge["meta"]): UpdateTopicPinnedKnowledge => ({
  meta,
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE,
});

export const updateTopicPinnedKnowledgeFulfilled = (
  meta: UpdateTopicPinnedKnowledgeFulfilled["meta"],
): UpdateTopicPinnedKnowledgeFulfilled => ({
  meta,
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE_FULFILLED,
});

export const updateTopicPinnedKnowledgeRejected = (
  meta: UpdateTopicPinnedKnowledgeRejected["meta"],
): UpdateTopicPinnedKnowledgeRejected => ({
  meta,
  type: PinAddRejectActionTypes.UPDATE_PINNED_KNOWLEDGE_REJECTED,
});

export const rejectTopicKnowledge = (meta: RejectTopicKnowledge["meta"]): RejectTopicKnowledge => ({
  meta,
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE,
});

export const rejectTopicKnowledgeFulfilled = (
  meta: RejectTopicKnowledgeFulfilled["meta"],
): RejectTopicKnowledgeFulfilled => ({
  meta,
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE_FULFILLED,
});

export const rejectTopicKnowledgeRejected = (meta: RejectTopicKnowledge["meta"]): RejectTopicKnowledgeRejected => ({
  meta,
  type: PinAddRejectActionTypes.REJECT_KNOWLEDGE_REJECTED,
});

export const approveKnowledge = (meta: ApproveKnowledge["meta"]): ApproveKnowledge => ({
  meta,
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE,
});

export const approveKnowledgeFulfilled = (meta: ApproveKnowledgeFulfilled["meta"]): ApproveKnowledgeFulfilled => ({
  meta,
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE_FULFILLED,
});

export const approveKnowledgeRejected = (meta: ApproveKnowledgeRejected["meta"]): ApproveKnowledgeRejected => ({
  meta,
  type: PinAddRejectActionTypes.APPROVE_KNOWLEDGE_REJECTED,
});

export const fetchTopicsForPinnedKnowledge = (
  meta: FetchTopicsForPinnedKnowledge["meta"],
): FetchTopicsForPinnedKnowledge => ({
  meta,
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE,
});

export const fetchTopicsForPinnedKnowledgeFulfilled = (
  meta: FetchTopicsForPinnedKnowledgeFulfilled["meta"],
  payload: FetchTopicsForPinnedKnowledgeFulfilled["payload"],
): FetchTopicsForPinnedKnowledgeFulfilled => ({
  meta,
  payload,
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_FULFILLED,
});

export const fetchTopicsForPinnedKnowledgeRejected = (
  meta: FetchTopicsForPinnedKnowledgeRejected["meta"],
): FetchTopicsForPinnedKnowledgeRejected => ({
  meta,
  type: PinAddRejectActionTypes.FETCH_TOPICS_FOR_PINNED_KNOWLEDGE_REJECTED,
});
